import { DateTimePicker } from "@mui/x-date-pickers";
import { useToastContext } from 'components/alert/ToastContext';
import AnexoPanel, { getFormData } from 'components/anexo/AnexoPanel';
import BaseCadastro from "components/BaseCadastro";
import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Pessoa from 'model/administracao/cadastro/Pessoa';
import Produto from "model/administracao/cadastro/produto/Produto";
import Local from "model/patrimonio/Local";
import Patrimonio from "model/patrimonio/Patrimonio";
import ProdutoCadastro from 'pages/administracao/cadastro/produto/ProdutoCadastro';
import { AutoComplete } from "primereact/autocomplete";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { useLoadingContext } from 'provider/LoadingProvider';
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import PatrimonioService from "service/patrimonio/PatrimonioService";
import UsuarioLogadoService from 'service/usuario/UsuarioLogadoService';
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";

const patrimonioService = new PatrimonioService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function PatrimonioCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [patrimonio, setPatrimonio] = useState<Patrimonio>(new Patrimonio());
    const [titulo, setTitulo] = useState<string>('Patrimônio');
    const [editando, setEditando] = useState<boolean>(false);
    const [produtosPatrimoniaveis, setProdutosPatrimoniaveis] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);
    const [locais, setLocais] = useState<Local[]>([]);
    const [novoLocal, setNovoLocal] = useState<Local>(new Local());
    const [fornecedores, setFornecedores] = useState<Pessoa[]>([]);
    const [visibleMudarLocal, setVisibleMudarLocal] = useState<boolean>(false);
    const [visibleDescartar, setVisibleDescartar] = useState<boolean>(false);
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const [anexos, setAnexos] = useState<any[]>([])
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);
    const [mudaLocais, setMudaLocais] = useState<boolean>(false);
    const [visibleCadastroProduto, setVisibleCadastroProduto] = useState<boolean>(false);

    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }

        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "PATRIMONIO_MUDAR_LOCAL")) {
                setMudaLocais(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

        patrimonioService.produtosPatrimoniaveis().then((data) => {
            setProdutosPatrimoniaveis(data);
        }).catch((error) => {
            console.log(error);
        });

        patrimonioService.locais().then((data) => {
            setLocais(data);
        }).catch((error) => {
            console.log(error);
        });

        patrimonioService.fornecedores().then((data) => {
            setFornecedores(data);
        }).catch((error) => {
            console.log(error);
        });
    }, [])

    function validar() {

        if (!patrimonio.codigo) {
            setError("codigo", { type: "manual", message: "Código é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!patrimonio.cdProduto) {
            setError("produto", { type: "manual", message: "produto é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!patrimonio.local?.id) {
            setError("local", { type: "manual", message: "local é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!patrimonio.dataRecebimento) {
            setError("dataRecebimento", { type: "manual", message: "Data é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    function botoesExtra() {
        return (
            <>
                {patrimonio.id && mudaLocais ? <Button label="Mudar Local" style={{ marginLeft: 10 }} onClick={() => {
                    setVisibleMudarLocal(true);
                }} /> : null}
                {patrimonio.status === "CRIADO" ? <Button label="Inutilizar" style={{ marginLeft: 10 }} onClick={() => {
                    setVisibleDescartar(true);
                }} /> : null}
                {patrimonio.status === "AGUARDANDO_DESCARTE" ? <Button label="Descartar" style={{ marginLeft: 10 }} onClick={() => {
                    descartar()
                }} /> : null}
                {patrimonio.status === "DESCARTADO" || patrimonio.status === "AGUARDANDO_DESCARTE" ? <Button label="Disponibilizar" style={{ marginLeft: 10 }} onClick={() => {
                    disponibilizar();
                }} /> : null}
                <Button type="button" label="Adicionar Produto" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => { setVisibleCadastroProduto(true) }}></Button>
            </>
        )
    }

    function mudarLocal() {
        startLoading();
        patrimonioService.mudarLocal(patrimonio.id, novoLocal)
            .then(() => {
                stopLoading();
                patrimonioService.consultar(patrimonio.id).then((data: Patrimonio) => setPatrimonio(data)).catch((e) => console.error(e));
            }).catch((error) => {
                stopLoading();
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro("Patrimonio", error.data.message);
                } else {
                    msgErro("Patrimonio", "Ocorreu um erro ao tentar mudar o Local, tente novamente!");
                }
            });
    }

    const descartar = () => {
        patrimonioService.descartar(patrimonio.id).then(() => {
            patrimonioService.consultar(patrimonio.id).then((data: Patrimonio) => setPatrimonio(data)).catch((e) => console.error(e));
        }).catch((error) => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Patrimonio", error.data.message);
            } else {
                msgErro("Patrimonio", "Ocorreu um erro ao tentar descartar Patrimonio, tente novamente!");
            }
        });
    }

    const inutilizar = () => {
        patrimonioService.inutilizar(patrimonio).then(() => {
            patrimonioService.consultar(patrimonio.id).then((data: Patrimonio) => setPatrimonio(data)).catch((e) => console.error(e));
        }).catch((error) => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Patrimonio", error.data.message);
            } else {
                msgErro("Patrimonio", "Ocorreu um erro ao tentar inutilizar Patrimonio, tente novamente!");
            }
        });
    }

    const disponibilizar = () => {
        patrimonioService.disponibilizar(patrimonio.id).then(() => {
            patrimonioService.consultar(patrimonio.id).then((data: Patrimonio) => setPatrimonio(data)).catch((e) => console.error(e));
            msgSucesso("Patrimonio", "Patrimonio disponibilizado com sucesso")
        }).catch((error) => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Patrimonio", error.data.message);
            } else {
                msgErro("Patrimonio", "Ocorreu um erro ao tentar disponibilizar o Patrimonio, tente novamente!");
            }
        });
    }

    return (

        <BaseCadastro
            getModel={() => {

                const data = getFormData("patrimonio", patrimonio, anexos);
                return data;

            }}
            setModel={(value: Patrimonio) => {
                setPatrimonio(value);
                setAnexos([])
            }}
            model={patrimonio}
            novoCadastro
            getNewModel={() => new Patrimonio()}
            service={patrimonioService}
            validar={() => validar()}
            urlService="/patrimonio"
            pathCadastro="/patrimonio"
            tituloPagina={'Patrimônio'}
            botoesExtra={botoesExtra()}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <Dialog header="Mudar Local" visible={visibleMudarLocal} style={{ width: '35vw' }} onHide={() => setVisibleMudarLocal(false)}>
                <div className="row">
                    <Label className="col col-sm-12" obrigatorio>Novo Local</Label>
                    <div className="col-sm-12">
                        <Controller name="novoLocal" control={control} render={({ field }) => (
                            <Dropdown
                                value={novoLocal}
                                options={locais}
                                optionLabel="nome"
                                onChange={(e) => {
                                    setNovoLocal(e.value)
                                }}
                                style={{ width: '95%' }}
                            />
                        )} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <Button disabled={novoLocal.id == 0} label="Mudar Local" style={{ marginRight: 30 }} onClick={() => {
                            mudarLocal();
                            setVisibleMudarLocal(false);
                        }} />
                    </div>
                </div>
            </Dialog>

            <Dialog header="Observação Inutilizavel" visible={visibleDescartar} style={{ width: '35vw' }} onHide={() => setVisibleDescartar(false)}>
                <div className="row">
                    <div className="col-sm-12">
                        <Label className="col col-sm-12" obrigatorio>Observação inutilizavel</Label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <InputTextarea
                            required
                            value={patrimonio.observacaoInutilizavel || ''}
                            style={{ width: '50%' }}
                            rows={4}
                            onChange={(e) => {
                                setPatrimonio({ ...patrimonio, observacaoInutilizavel: e.target.value })
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <Button label="Confirmar" disabled={!patrimonio.observacaoInutilizavel} style={{ marginRight: 30 }} onClick={() => {
                            setVisibleDescartar(false)
                            inutilizar();
                        }} />
                    </div>
                </div>
            </Dialog>
            <Dialog header="Cadastro de Produto" visible={visibleCadastroProduto} onHide={() => setVisibleCadastroProduto(false)} style={{ width: '75vw' }} >
                <ProdutoCadastro isModal isPatrimonio onSave={() => {
                    setVisibleCadastroProduto(false);
                    patrimonioService.produtosPatrimoniaveis().then((data) => {
                        setProdutosPatrimoniaveis(data);
                    }).catch((error) => {
                        console.log(error);
                    });
                }} />
            </Dialog>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={patrimonio.codigo}
                        className={errors.codigo ? "p-invalid" : ""}
                        style={{ width: '50%' }}
                        {...register("codigo", {
                            onChange: (e) => {
                                setPatrimonio({ ...patrimonio, codigo: e.target.value })
                                clearErrors("codigo")
                            }
                        })}
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Número da Nota Fiscal</Label>
                <div className="col-sm-12">
                    <InputNumber
                        useGrouping={false}
                        maxFractionDigits={0}
                        required value={patrimonio.numeroNotaFiscal}
                        style={{ width: '50%' }}
                        onChange={(e) => {
                            setPatrimonio({ ...patrimonio, numeroNotaFiscal: e.value })
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Produto</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        disabled={patrimonio.id ? true : false}
                        dropdown
                        placeholder="Selecione o produto"
                        value={patrimonio.produto}
                        suggestions={produtosFiltrados}
                        field="nome"
                        className={errors.produto ? "p-invalid" : ""}
                        itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                        completeMethod={(e) => {
                            let filtered = produtoCompleteMethod(produtosPatrimoniaveis, e.query);
                            setProdutosFiltrados(filtered);
                        }}
                        onChange={(e) => {
                            if (typeof e.target.value == "string") {
                                let prod = new Produto();
                                prod.nome = e.target.value;
                                patrimonio.produto = prod;
                                patrimonio.cdProduto = null;
                            } else {
                                patrimonio.produto = e.target.value;
                                patrimonio.cdProduto = patrimonio.produto?.codigo ?? null;
                                clearErrors("produto");
                            }
                            setPatrimonio({ ...patrimonio })
                        }}

                        inputStyle={{ width: '100%' }}
                        style={{ width: '30%' }}
                    />
                </div>
                {errors.produto && errors.produto.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.produto?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Número de Série</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={patrimonio.numeroSerie}
                        style={{ width: '50%' }}
                        onChange={(e) => {
                            setPatrimonio({ ...patrimonio, numeroSerie: e.target.value })
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Modelo</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={patrimonio.modelo}
                        style={{ width: '32.5%' }}
                        onChange={(e) => {
                            setPatrimonio({ ...patrimonio, modelo: e.target.value })
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Local</Label>
                <div className="col-sm-12">
                    <Controller name="local" control={control} render={({ field }) => (
                        <Dropdown
                            disabled={patrimonio.id ? true : false}
                            focusInputRef={field.ref}
                            value={patrimonio.local}
                            className={errors.local ? "p-invalid" : ""}
                            options={locais}
                            optionLabel="nome"
                            onChange={(e) => {
                                clearErrors("local")
                                setPatrimonio({ ...patrimonio, local: e.value })
                            }}
                            style={{ width: '30%' }}
                        />
                    )} />
                </div>
                {errors.local && errors.local.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.local?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Fornecedor</Label>
                <div className="col-sm-12">
                    <Controller name="fornecedor" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            value={patrimonio.fornecedor}
                            options={fornecedores}
                            optionLabel="nome"
                            onChange={(e) => {
                                setPatrimonio({ ...patrimonio, fornecedor: e.value })
                            }}
                            style={{ width: '30%' }}
                        />
                    )} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Preço</Label>
                <div className="col-sm-12" style={{ width: '30%' }}>
                    <InputMonetario value={patrimonio.preco || 0}
                        onChange={(e) => {
                            patrimonio.preco = e;
                            setPatrimonio({ ...patrimonio })
                        }}

                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Status</Label>
                <div className="col-sm-12">
                    <InputText disabled value={patrimonioService.getStatus(patrimonio.status)} style={{ width: '30%' }} />
                </div>
            </div>

            {patrimonio.status === "AGUARDANDO_DESCARTE" || patrimonio.status === "DESCARTADO" ? <div className="row">
                <Label className="col col-sm-12" obrigatorio>Observação inutilizavel</Label>
                <div className="col-sm-12">
                    <InputTextarea disabled value={patrimonio.observacaoInutilizavel ? patrimonio.observacaoInutilizavel : ""} rows={4} style={{ width: '100%' }} />
                </div>
            </div> : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data Recebimento</Label>
                <div className="col-sm-12">
                    <Controller name="dataRecebimento" control={control} render={({ field }) => (

                        <DateTimePicker
                            inputRef={field.ref}
                            className={errors.dataRecebimento ? "p-invalid" : ""}
                            value={dayjs(patrimonio.dataRecebimento)}
                            ampm={false}
                            onChange={value => {
                                clearErrors("dataRecebimento")
                                setPatrimonio({ ...patrimonio, dataRecebimento: value?.toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataRecebimento && errors.dataRecebimento.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataRecebimento?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea
                        required value={patrimonio.observacao || ''}
                        style={{ width: '50%' }}
                        rows={4}
                        onChange={(e) => {
                            setPatrimonio({ ...patrimonio, observacao: e.target.value })
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <AnexoPanel
                        novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                        arquivos={patrimonio.arquivos} onChange={(e) => {
                            setPatrimonio({ ...patrimonio, arquivos: e })
                        }}
                        collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                    />
                </div>
            </div>
        </BaseCadastro>
    )
}